module.exports = __webpack_public_path__ + "img/quanshanghuiyuan.041cb7a9.png";